module.exports = __webpack_public_path__ + "static/media/box-1.9f9dec27.svg";